import { useNavigate } from "react-router-dom"
import { useState } from "react"
import editProfile from 'assets/images/editProfile.svg'
import AddProfilePic from "components/AddProfilePic"


const Settings = () => {
   
    const navigate = useNavigate()  
    const [ showProfileModal, toggleProfileModal ] = useState(false)

    return(
        <div className="p-8" >
            <AddProfilePic show={showProfileModal} toggleClose={()=>toggleProfileModal(!showProfileModal)} />


            <h4>Change settings </h4>
            <div className=" grid grid-cols-4 gap-4">
                <div className="mt-16">
                    <p className=" text-secondary text-sm cursor-pointer mb-2" onClick={()=>navigate("/dashboard/update_profile")}  >
                    <img className="md:h-14 md:w-14 lg:w-18 lg:h-18 xl:w-20 xl:h-20 w-20 h-10 bg"  src={editProfile} alt={"+ update profile"} /> 
                    <span>edit profile</span>
                    </p>
                </div>
                <div className="mt-16">
                    <p className=" text-secondary text-sm cursor-pointer mb-2" onClick={()=>toggleProfileModal(!showProfileModal)}  >
                    <img className="md:h-14 md:w-14 lg:w-18 lg:h-18 xl:w-20 xl:h-20 w-20 h-10 bg"  src={editProfile} alt={"+ update profile"} /> 
                    <span>change profile picture</span>
                    </p>
                </div>
            </div>
        </div>       
)}

export default Settings